import { Pipe, PipeTransform } from '@angular/core';
import { OverPackagingModel } from '../../models/over-packaging.model';

@Pipe({
  name: 'calculatedName',
})
export class CalculatedNamePipe implements PipeTransform {
  transform(item: OverPackagingModel, translations: any): unknown {
    const packagingTypeString = item.PackingType ? ` (${item.PackingType})` : '';
    return `${item.Amount} ${translations['OverPackModalTitle']}${packagingTypeString} ${item.Identification}`;
  }
}
